// extracted by mini-css-extract-plugin
export default {"tableWrap":"ProfileTable_tableWrap__EAJfI","tableHeader":"ProfileTable_tableHeader__rcqL-","table":"ProfileTable_table__d9dBm"};